if (!customElements.get('mimi-home')) {
  customElements.define('mimi-home', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.video = this.querySelector('video');
      this.playButton = this.querySelector('[data-video-toggle]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;
      this.inView = true;
      const status = this.querySelector('[data-video-status]');
      const play = () => {
        if (this.video && !this.video.error) this.video.play().catch(() => {
          this.playButton.textContent = '動画を再生 ▶';
        });
      };
      const syncPlayback = () => {
        if (!this.video) return;
        if (document.hidden || !this.inView || this.motion.matches || this.userPaused) this.video.pause();
        else play();
      };
      if (this.video) {
        this.video.muted = true;
        // Native controls remain available when JavaScript cannot run.
        this.video.controls = false;
        this.playButton.hidden = false;
        this.playButton.addEventListener('click', () => {
          this.userPaused = !this.video.paused;
          if (this.video.paused) play();
          else this.video.pause();
        }, options);
        this.video.addEventListener('play', () => {
          this.playButton.textContent = '一時停止 Ⅱ';
          this.playButton.setAttribute('aria-label', '動画を一時停止');
        }, options);
        this.video.addEventListener('pause', () => {
          this.playButton.textContent = '動画を再生 ▶';
          this.playButton.setAttribute('aria-label', '動画を再生');
        }, options);
        const showError = () => {
          this.playButton.hidden = true;
          status.hidden = false;
          this.video.controls = true;
        };
        this.video.addEventListener('error', showError, options);
        if (this.video.error) showError();
        document.addEventListener('visibilitychange', syncPlayback, options);
        this.motion.addEventListener('change', syncPlayback, options);
        if ('IntersectionObserver' in window) {
          this.videoObserver = new IntersectionObserver(([entry]) => {
            this.inView = entry.isIntersecting;
            syncPlayback();
          }, { threshold: 0.15 });
          this.videoObserver.observe(this.video);
        }
        syncPlayback();
      }
      if (!this.motion.matches && !window.Shopify?.designMode) {
        this.querySelector('.mimi-home__title')?.classList.add('is-animated');
        if ('IntersectionObserver' in window) {
          this.revealObserver = new IntersectionObserver((entries) => {
            entries.forEach(({ target, isIntersecting }) => {
              if (isIntersecting) {
                target.classList.add('is-visible');
                this.revealObserver.unobserve(target);
              }
            });
          }, { threshold: 0.08 });
          this.querySelectorAll('.mimi-home__reveal').forEach((element) => {
            element.classList.add('is-ready');
            this.revealObserver.observe(element);
          });
        }
      }
      const more = this.querySelector('[data-faq-more]');
      const extra = this.querySelector('[data-faq-extra]');
      if (more && extra && !window.Shopify?.designMode) {
        extra.hidden = true;
        more.hidden = false;
        more.addEventListener('click', () => {
          extra.hidden = !extra.hidden;
          more.setAttribute('aria-expanded', String(!extra.hidden));
          more.textContent = extra.hidden ? 'すべての質問を見る ＋' : '質問を少なく表示 −';
        }, options);
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.videoObserver?.disconnect();
      this.revealObserver?.disconnect();
      this.video?.pause();
    }
  });
}
